<template>
  <div class="container">
    <div class="conmonContent">
      <div class="w1600">
        <div class="otDetail d-flex j-sb">
          <!-- 左侧详情 -->
          <div class="otLeftContent">
            <!-- 视频区 -->
            <div class="tVideo bd10 p3" v-if="content.base">
              <!-- <p class="font18">UniVista Simulator</p> -->
              <h3 class="font36 line-sm">{{content.base.name}}</h3>
              <div class="tagList d-flex a-center">
                <i v-for="t in content.base.tag.split(',')" :key="t">{{t}}</i
                ><span class="font-light cor999">{{content.base.time}}</span>
              </div>
              <div class="dtable">
                <div class="table font-light line-mn">
                  <table>
                    <tbody>
                      <tr>
                        <th>{{$t('admin.installFiles')}}</th>
                        <th>{{ $t("admin.version") }}</th>
                        <th>{{ $t("admin.size") }}</th>
                        <!-- <th>{{ $t("admin.format") }}</th> -->
                        <th>{{ $t("admin.releaseTime") }}</th>
                        <th v-if="$store.state.permissions?.includes('isVersionDown')"><div class="d-flex a-center j-center">{{ $t("admin.downloadBtn") }}</div></th>
                      </tr>
                      <tr v-for="(item, index) in content.installList" :key="index">
                        <td>
                          <div class="d-flex a-center">
                            <a  class="font18 font-medium pointer" @click="downloadFile(item.id,index)" :title="item.name">{{ item.name }}</a>
                          </div>
                        </td>
                        <td>{{item.no}}</td>
                        <td>{{ item.size }}</td>
                        <!-- <td>{{item.description}}</td> -->
                        <td>{{item.releaseDate}}</td>
                        <td v-if="$store.state.permissions?.includes('isVersionDown')">
                          <vdownload :id="item.id" path="" api="product/getVersionDetailsFile"></vdownload>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- 发布文档 -->
            <div class="download bd10 p3">
              <div class="oTitle d-flex j-start">
                <h4 class="font-medium h4 font20">{{$t('admin.publishedDocuments')}}</h4>
              </div>
              <div class="dtable">
                <div class="table font-light line-mn">
                  <table>
                    <tbody>
                      <tr>
                        <th>{{$t('admin.installFiles')}}</th>
                        <th>{{ $t("admin.version") }}</th>
                        <th>{{ $t("admin.size") }}</th>
                        <th>{{ $t("admin.releaseTime") }}</th>
                        <th v-if="$store.state.permissions?.includes('isVersionDown')"><div class="d-flex a-center j-center">{{ $t("admin.downloadBtn") }}</div></th>
                      </tr>
                      <tr v-for="(item, index) in content.documentList" :key="index">
                        <td>
                          <div class="d-flex a-center">
                            <a  class="font18 font-medium pointer" @click="downloadFile2(item.id,index)" :title="item.name">{{ item.name }}</a>
                          </div>
                        </td>
                        <td>{{item.no}}</td>
                        <td>{{ item.size }}</td>
                        <td>{{item.releaseDate}}</td>
                        <td v-if="$store.state.permissions?.includes('isVersionDown')">
                          <vdownload :id="item.id" path="" api="product/getVersionDetailsFile"></vdownload>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <!-- 右侧目录菜单 -->
          <div class="otRightMenu" v-if="content.base">
            <!-- 目录 -->
            <div class="directory bd10 p3">
              <div class="oTitle d-flex j-start">
                <h4 class="font-medium font18 h4">{{content.base.name}}</h4>
              </div>
              <ul>
                <li class="active pointer">{{$t('admin.installFiles')}}</li>
                <li class="pointer">{{$t('admin.publishedDocuments')}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "PackageDetail",
  components: {},
  data() {
    return {
      itemid:'',
      // 详细信息
      content: {
      },
    };
  },

  created() {
    // 获取详细信息
    this.itemid=this.$route.query.id;
    this.getContentInfo(this.itemid);
  },

  mounted() {
    
  },

  methods: {
    downloadFile(id,index){
      var that=this;
      if(that.content.installList[index].dp!=0){return;}
      that.$daxios
        .get(`product/getVersionDetailsFile?id=${id}`,{
          responseType: 'blob',
          onDownloadProgress:e=>{
            that.content.installList[index].dp=Math.floor(e.progress*100);
          },
        })
        .then((res) => {
          if(res.data&&res.data.size==0){
            that.content.installList[index].dp=0;
            that.$message({
              message:"下载失败",
              type: 'error'
            });
			      return;
          };
          const url = window.URL.createObjectURL(new Blob([res.data]),{ type: res.headers['content-type'] });
          const link = document.createElement('a');
          let fileName = res.headers['content-disposition'].split('=').pop();
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((err) => { 
          that.content.installList[index].dp=0;
        });
    },
    downloadFile2(id,index){
      var that=this;
      if(that.content.documentList[index].dp!=0){return;}
      that.$daxios
        .get(`product/getVersionDetailsFile?id=${id}`,{
          responseType: 'blob',
          onDownloadProgress:e=>{
            that.content.documentList[index].dp=Math.floor(e.progress*100);
          },
        })
        .then((res) => {
          if(res.data&&res.data.size==0){
            that.content.documentList[index].dp=0;
            that.$message({
              message:"下载失败",
              type: 'error'
            });
			      return;
          };
          const url = window.URL.createObjectURL(new Blob([res.data]),{ type: res.headers['content-type'] });
          const link = document.createElement('a');
          let fileName = res.headers['content-disposition'].split('=').pop();
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch((err) => { 
          that.content.documentList[index].dp=0;
        });
    },
    // 页面跳转
    goToPage(path, query = {}) {
      this.$router.push({
        path,
        query,
      });
    },

    // 页面滚动对应位置右边对应信息高亮
    scrollTitleCurrent() {
      let detailTop = $(".tVideo").offset().top - 90;
      $(window).on("scroll", function () {
        let scrollTop = $(this).scrollTop();
        if (scrollTop >= detailTop) {
          $(".directory ul li")
            .eq(1)
            .addClass("active")
            .siblings()
            .removeClass("active");
        }  else {
          $(".directory ul li")
            .eq(0)
            .addClass("active")
            .siblings()
            .removeClass("active");
        }
      });
    },

    // 右边信息点击页面滚动对应位置
    titleScrollPosition() {
      let detailTop = $(".tVideo").offset().top;
      let downloadTop = $(".download").offset().top;
      $(".directory ul li").click(function () {
        let index = $(this).index();
        if (index == 0) {
          $("html,body").stop().animate({ scrollTop: 0 }, 800);
        } else{
          $("html,body").stop().animate({ scrollTop: downloadTop }, 800);
        }
      });
    },

    // 获取详细信息
    getContentInfo(id) {
      this.$axios
        .get(`product/versionDetails?id=${id}`)
        .then((res) => {
          let data = res.data;
          // 当前产品信息
          res.data.documentList.forEach(i=>{i.dp=0});
          res.data.installList.forEach(i=>{i.dp=0});
          this.content = data;
          this.$nextTick(function(){
            // 更新页面滚动对应位置右边对应信息高亮
            this.scrollTitleCurrent();
            // 右边信息点击页面滚动对应位置
            this.titleScrollPosition();
          })
        })
        .catch((err) => {});
    },
  },

  // 监听
  watch: {
    // 路由变化
    $route(to, from) {
      // 重新获取详细信息
      this.getContentInfo(this.$route.query.id);
    },
  },
};
</script>
  
  <style lang="less" scoped>
.tagList {
  margin-bottom: 0.2rem;
  i {
    margin-bottom: 0;
    margin-right: 0.1rem !important;
    background: #2f71e3;
  }
  span {
    padding: 0 0.1rem;
  }
}
.table {
  table {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    border: none;
  }
  th,
  td {
    padding: 0.2rem;
  }
  td{
    &:first-child{
		padding-left: .44rem;
	}
  }
  th {
    border: none;
    background: #f2f5fa;
	text-align: left;
	font-weight: normal;
	color: #333;
	&:first-child{
		border-radius: 8px 0 0 8px;
		padding-left: .44rem;
	}
	&:last-child{
		border-radius: 0 8px 8px 0;
    width: 150px;
	}
  }
  td {
    border: none;
    border-bottom: 1px solid #f1f1f1;
	a{
		color:inherit;
	}
  }
  tr:last-child td {
    border: none;
  }
  .d {
    width: 0.14rem;
    height: 0.16rem;
	margin-right: .1rem;
    background: url(@/assets/Icons/downloadBlack.png) no-repeat center/100% 100%;
  }
  tr:hover {
    color: #2f71e3;
    .d {
      background-image: url(@/assets/Icons/downloadBlue.png);
    }
  }
}
.otDetail {
  padding-top: 0.6rem;
  align-items: flex-start;
  .otLeftContent {
    width: calc(100% - 3.5rem);
  }
  .otRightMenu {
    width: 3.3rem;
    position: sticky;
    top: 1rem;
  }
  @media (max-width: 1200px) {
    flex-direction: column;
    .otLeftContent,
    .otRightMenu {
      width: 100%;
    }

    .otRightMenu {
      margin-top: 0.3rem;
      .directory {
        display: none;
      }
    }
  }
}
.otRightMenu {
  .directory {
    margin-bottom: 0.1rem;
    ul li {
      &:not(:last-child) {
        margin-bottom: 0.15rem;
      }
      &:hover,
      &.active {
        color: #3076e3;
      }

      a {
        width: 70%;
      }
    }
  }
  .train {
    ul li {
      padding: 0.15rem 0;
      &:nth-of-type(1) {
        padding-top: 0;
      }
      &:not(:last-child) {
        border-bottom: solid 1px #eee;
      }
    }
  }
}
.otLeftContent {
  & > div:not(:last-child) {
    margin-bottom: 0.1rem;
  }
  .info {
    .desc {
      margin-top: 0.3rem;
    }
    dl dd {
      margin-top: 0.2rem;
      position: relative;
      padding-left: 0.2rem;
      &:after {
        content: "";
        position: absolute;
        left: 0;
        top: 0.03rem;
        width: 0.08rem;
        height: 0.08rem;
        border-radius: 50%;
        background: #45adf2;
      }
    }
  }
  .download {
    ul {
      margin: 0 -0.1rem;
      margin-top: -0.2rem;
      li {
        border-bottom: 1px solid #f1f1f1;
        .item {
          padding: .15rem 0;
        }
        .t {
          flex: 1 1 auto;
		  overflow: hidden;
		  padding-right: 2em;
        }
        .time {
          flex: 0 0 auto;
        }
      }
    }
  }
  .intro {
    .desc {
      min-height: 1.5rem;
    }
  }
  .tVideo {
    .dImg {
      padding-top: 0.6rem;
      margin-top: 0.4rem;
      border-top: solid 1px #eee;
    }
    h3 {
      margin: 0.1rem 0 0.1rem;
    }
    i {
      margin-right: 0.2rem;
    }
  }
}
</style>
  